module.exports = __webpack_public_path__ + "img/IMG_0375.483e8ddc.jpg";